module.exports = __webpack_public_path__ + "media/images/emblems/Bueren-coat_of_arms-a917123a775b1f1a7055dfabebf19362.svg";